import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import DceAjax from "dce-ajax/lib/ajax/DceAjax";
import Logger from "dce-logger/lib/logger/Logger";
import DceAjaxResponse from "dce-ajax/lib/ajax/DceAjaxResponse";
import {DceEngine} from "dce-engine";
import DceEngineEventDetails from "../../../../dce-engine/lib/engine/events/DceEngineEventDetails";
import DceEngineEvents from "../../../../dce-engine/lib/engine/events/DceEngineEvents";
import Dialog from "./Dialog";

interface OpenDialogProps {
    target?: string;
    bindClick: boolean;
    url?: string;
    replaceElementClosest?: string;
}

@Dce("OpenDialog")
export default class OpenDialog extends DceComponent<OpenDialogProps> {

    protected logger = Logger.of("OpenDialog");

    private button: JQuery<HTMLElement>;

    private target: JQuery<HTMLElement>;

    private closeEvents: ((o: Dialog, e: HTMLElement) => void)[] = [];

    private closeSavedEvents: ((o: Dialog, e: HTMLElement) => void)[] = [];

    constructor(elem: DceHTMLElement, props: OpenDialogProps) {
        super(elem, props);
        this.button = $(elem);

        this.target = $(this.props.target);

        if(this.target.length == 0){
            this.target = $('body');
        }

        if(this.props.bindClick) {
            this.button.on('click', e => {
                e.preventDefault();
                this.loadDialog();
            });
        }

    }

    /**
     * o - obiek dialoga
     * e - element na
     * @param callback
     */
    public addOnClose(callback: (o: Dialog, e: HTMLElement) => void){
        this.closeEvents.push(callback);
    }

    public addOnSavedClose(callback: (o: Dialog, e: HTMLElement) => void){
        this.closeSavedEvents.push(callback);
    }

    public loadDialog(){

        this.target.addClass('loading');

        DceAjax.getInstance()
            .get(this.props.url)
            .then((resp: DceAjaxResponse) => {
                this.openDialog(resp.response, false);
                this.target.removeClass('loading');
            });

    }

    public loadDialogWithPost(data:any){
        this.target.addClass('loading');

        DceAjax.getInstance()
            .post(this.props.url, data)
            .then((resp: DceAjaxResponse) => {
                this.openDialog(resp.response, false);
                this.target.removeClass('loading');
            });

    }

    protected openDialog(html: string, nextStep:boolean, target: JQuery<HTMLElement> = null){
        let view = $(html);

        view[0].addEventListener('dceEvent', ((e: CustomEvent<DceEngineEventDetails>) => {

            if(e.detail.type == DceEngineEvents.SUBCOMP_INIT_EVENT
                && e.detail.component == 'Dialog'
            ){

                let modalElement = e.detail.element;
                let openedDialog = modalElement.ext.getComponent('Dialog') as Dialog;

                openedDialog.dialogIsNextStep = nextStep;

                this.logger.debug("Attach dialog close event", modalElement, openedDialog);
                openedDialog.addOnClose((d, e) => {
                    this.dialogCloseEvent(d, e)
                });

                return;
            }

        }) as EventListener);

        DceEngine.getInstance().watchElement(view[0]);

        if(null != target){
            view.appendTo(target);
        }else{
            view.appendTo(this.target);
        }

    }

    private dialogCloseEvent(dialog:Dialog, elem:HTMLElement){
        this.logger.debug("close", dialog, elem);

        if(dialog.getFormSaved() && dialog.getFormResponse()){

            let actions = dialog.getFormResponse().getActions();

            if(actions.has('newDialog')){
                let nextTarget: JQuery<HTMLElement> = null;
                let nextTargetSelector = null;

                if(dialog.getFormResponse().hasData('newDialogTarget')){
                    nextTargetSelector = dialog.getFormResponse().getData('newDialogTarget');

                    if(null != nextTargetSelector && nextTargetSelector != ''){
                        nextTarget = $(nextTargetSelector);
                    }
                }

                if(null == nextTarget || nextTarget.length == 0){
                    nextTarget = this.target;
                }

                let nextUrl = actions.get('newDialog') as string;
                if(nextUrl == 'response'){
                    this.openDialog(dialog.getFormResponse().getData('newDialogContent'), false, nextTarget);
                    nextTarget.removeClass('loading');
                }else {

                    nextTarget.addClass('loading');

                    DceAjax.getInstance()
                        .get(nextUrl)
                        .then((resp: DceAjaxResponse) => {
                            this.openDialog(resp.response, false, nextTarget);
                            nextTarget.removeClass('loading');
                        });
                }
            }

            if(actions.has('nextDialog')){

                let nextTarget: JQuery<HTMLElement> = null;
                let nextTargetSelector = null;

                if(dialog.getFormResponse().hasData('nextDialogTarget')){
                    nextTargetSelector = dialog.getFormResponse().getData('nextDialogTarget');

                    if(null != nextTargetSelector && nextTargetSelector != ''){
                        nextTarget = $(nextTargetSelector);
                    }

                }

                if(null == nextTarget || nextTarget.length == 0){
                    nextTarget = this.target;
                }


                let nextUrl = actions.get('nextDialog') as string;
                if(nextUrl == 'response'){
                    this.openDialog(dialog.getFormResponse().getData('nextDialogContent'), true, nextTarget);
                    nextTarget.removeClass('loading');
                }else {

                    nextTarget.addClass('loading');

                    DceAjax.getInstance()
                        .get(nextUrl)
                        .then((resp: DceAjaxResponse) => {
                            this.openDialog(resp.response, true, nextTarget);
                            nextTarget.removeClass('loading');
                        });
                }

                return;
            }

            if(this.props.replaceElementClosest) {
                if (actions.has('replaceElement')) {

                    let closestReplace = this.button.closest(this.props.replaceElementClosest);

                    if(closestReplace.length > 0){
                        let newElement = $(actions.get("replaceElement"));
                        closestReplace.replaceWith(newElement);
                    }

                }
            }

        }

        this.logger.debug("Calling dialog close events!")

        this.closeEvents.forEach(callback => {
            callback(dialog, elem);
        });

        if (dialog.dialogIsNextStep || (!dialog.getFormBind() || (dialog.getFormBind() && dialog.getFormSaved()))) {

            this.closeSavedEvents.forEach(callback => {
                callback(dialog, elem);
            });

        }

    }

    defaultProps(): OpenDialogProps {
        let href = this.elem.getAttribute('href');
        return {
            target: "#main",
            bindClick: true,
            url: href
        };
    }
}
